import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepItemMapping extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Item Mapping: Resource Representations</h1>
				<h2>Item Mapping</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> item </td>
							<td> Object </td>
							<td> An object representation of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> item.no </td>
							<td> String</td>
							<td> Item's identification number in BrickLink catalog </td>
							<td> </td>
						</tr>
						<tr>
							<td> item.type </td>
							<td> String </td>
							<td> The type of the item </td>
							<td>PART </td>
						</tr>
						<tr>
							<td> color_id </td>
							<td> Integer </td>
							<td> Color ID of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> color_name </td>
							<td> String </td>
							<td> Color name of the item </td>
							<td>  </td>
						</tr>
						<tr>
							<td> element_id </td>
							<td> String </td>
							<td> Element ID of the item in specific color </td>
							<td> </td>
						</tr>
					</tbody>
				</table>
			</section>
		);
	}
}